import React from 'react';

const PagedListControl = ({
    isFirstPage,
    isLastPage,
    itemsFrom,
    itemsTo,
    pageCount,
    pageNumber,
    setPage,
    totalItems
}) => (

        <div className='bg-light border-top d-flex justify-content-center justify-content-sm-between'>
            <div className='d-none d-sm-flex justify-content-center' style={{ minWidth: '125px' }}>
                <span>{itemsFrom} to {itemsTo} of {totalItems}</span>
            </div>
            <div className='d-flex'>
                <div style={{ width: '60px', display: 'flex', justifyContent: 'center' }}>
                    {!isFirstPage &&
                        <div className='action-button' onClick={() => setPage(pageNumber - 1)}>
                            &lt;&lt;&lt;
                        </div>
                    }
                </div>
                <div>
                    <span>Page {pageNumber} of {pageCount}</span>
                </div>
                <div style={{ width: '60px', display: 'flex', justifyContent: 'center' }}>
                    {!isLastPage &&
                        <div className='action-button' onClick={() => setPage(pageNumber + 1)}>
                            &gt;&gt;&gt;
                        </div>
                    }
                </div>
            </div>
        </div>
    );

export default PagedListControl;